import { render, staticRenderFns } from "./ReportWidget.vue?vue&type=template&id=f49dd980&scoped=true"
import script from "./ReportWidget.vue?vue&type=script&lang=js"
export * from "./ReportWidget.vue?vue&type=script&lang=js"
import style0 from "./ReportWidget.vue?vue&type=style&index=0&id=f49dd980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49dd980",
  null
  
)

export default component.exports